import { AlertOctagon, AlertTriangle, AlertCircle, Info } from 'lucide-react';
import { C, FONTS } from '../../tokens/design';
import { normalizeSeverity } from '../../utils/severity';

const SEVERITY_STYLES = {
  critical: { color: C.red, bg: C.redBg, Icon: AlertOctagon },
  high:     { color: C.org, bg: C.orgBg, Icon: AlertTriangle },
  medium:   { color: C.amb, bg: C.ambBg, Icon: AlertCircle },
  low:      { color: C.sky, bg: C.skyBg, Icon: Info },
  info:     { color: C.gry, bg: C.gryBg, Icon: Info },
};

export default function SeverityBadge({ value }) {
  const label = normalizeSeverity(value);
  const s = SEVERITY_STYLES[label.toLowerCase()] || SEVERITY_STYLES.info;
  const { color, bg, Icon } = s;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '2px 8px', borderRadius: 9999,
      fontSize: 11, fontWeight: 600, letterSpacing: '0.04em',
      fontFamily: FONTS.mono, color, background: bg,
      border: `1px solid ${color}33`,
    }}><Icon size={11} strokeWidth={2} />{label}</span>
  );
}
